import { defineStore } from 'pinia'

interface ToastState {
  message: string | null
  type: 'ok' | 'ng'
}

let timer: ReturnType<typeof setTimeout> | undefined

export const useToastStore = defineStore('toast', {
  state: (): ToastState => ({
    message: null,
    type: 'ok',
  }),
  actions: {
    show(message: string, type: 'ok' | 'ng' = 'ok') {
      this.message = message
      this.type = type
      if (timer) clearTimeout(timer)
      timer = setTimeout(() => {
        this.message = null
      }, 3200)
    },
  },
})